(function(){
  const NS = 'Askrift';

  // ------------------------- Utils -------------------------
  const utils = {
    money(cents){
    const int = Number.isFinite(Number(cents)) ? Number(cents) : 0;
    const kr  = Math.ceil(int / 100);                           // ← round UP to whole kr
    const num = new Intl.NumberFormat('en-US', {                // comma thousands
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    }).format(kr);
    return `${num} kr`;                                    // NBSP before kr
    },
    normalize(s){
      return (s||'').toString().trim().toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g,'')
        .replace(/\s+/g,' ');
    },
    markBound(el, key){ el.setAttribute(`data-${key||'askrift-bound'}`, '1'); },
    isBound(el, key){ return el.getAttribute(`data-${key||'askrift-bound'}`) === '1'; },
  };

    function toUrl(x){
        if (!x) return '';
        if (typeof x === 'string') return x;
        if (typeof x === 'object') {
            return x.src || x.url || x.originalSrc || x.currentSrc || '';
        }
        return String(x);
    }

  // ---------------- Handvirkt "UPPSELT" (2026-09-10) ----------------
  // Payload-lykillinn `forced_sold_out` kemur úr sections/askrift.liquid, sem les hann úr
  // snippets/hh-forced-soldout.liquid (shop metafield custom.sold_out_skus). Afbrigði sem er
  // ÞVINGAÐ uppselt á að hegða sér NÁKVÆMLEGA eins og afbrigði sem er raunverulega uppselt.
  // Birgðastaðan sjálf er aldrei snert — `available` er óbreytt í payloadinu.
  // FAIL-OPEN: vanti báðir lyklarnir (eldra payload) telst afbrigðið seljanlegt eins og áður.
  function isSellable(v){
    if (!v) return false;
    const inStock = (v.is_available ?? v.available ?? true);
    return !!inStock && v.forced_sold_out !== true;
  }

  // ---------------------- Dropdown UI ----------------------
  const dropdown = {
    bind(drop){
      if (!drop || utils.isBound(drop, 'dropdown')) return;

      const btn = drop.querySelector('[data-dropdown-button]');
      const list = drop.querySelector('.dropdown__list');
      const label = drop.querySelector('[data-dropdown-label]');
      if(!btn || !list || !label){ utils.markBound(drop, 'dropdown'); return; }

      let open = false;
      const setOpen = (v) => {
        open = !!v;
        drop.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
        if(open) list.focus();
      };

      btn.addEventListener('click', (e) => { e.stopPropagation(); setOpen(!open); });
      btn.addEventListener('keydown', (e) => {
        if(e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' '){
          e.preventDefault(); setOpen(true);
          const first = list.querySelector('.dropdown__option');
          if(first){ list.querySelectorAll('.dropdown__option').forEach(o=>o.classList.remove('is-focused')); first.classList.add('is-focused'); }
        }
      });
      list.addEventListener('keydown', (e) => {
        const opts = Array.from(list.querySelectorAll('.dropdown__option'));
        const cur = opts.findIndex(o => o.classList.contains('is-focused'));
        if(e.key === 'Escape'){ e.preventDefault(); setOpen(false); btn.focus(); }
        if(e.key === 'ArrowDown'){ e.preventDefault(); const i = Math.min(cur+1, opts.length-1); opts.forEach(o=>o.classList.remove('is-focused')); opts[i].classList.add('is-focused'); opts[i].scrollIntoView({block:'nearest'}); }
        if(e.key === 'ArrowUp'){ e.preventDefault(); const i = Math.max(cur-1, 0); opts.forEach(o=>o.classList.remove('is-focused')); opts[i].classList.add('is-focused'); opts[i].scrollIntoView({block:'nearest'}); }
        if(e.key === 'Enter'){ e.preventDefault(); (opts[cur]||opts[0])?.click(); }
      });
        list.addEventListener('click', (e) => {
        const item = e.target.closest('.dropdown__option');
        if(!item) return;

        list.querySelectorAll('.dropdown__option').forEach(li => {
            const sel = li === item;
            li.classList.toggle('is-selected', sel);
            li.setAttribute('aria-selected', sel ? 'true' : 'false');
        });

        const raw = item.dataset.value;              // exact Shopify option
        const nice = item.dataset.display || raw;    // stripped label for UI
        label.textContent = nice;

        setOpen(false);
        drop.dispatchEvent(new CustomEvent('dropdown:change', {
            bubbles: true,
            detail: { value: raw }                      // keep RAW for matching
        }));
        });
      document.addEventListener('click', (e) => { if(!drop.contains(e.target)) setOpen(false); });

      utils.markBound(drop, 'dropdown');
    }
  };

  // ------------------- Card / Variant logic -------------------
  const cards = {
    hydrate(card){
      if (!card || utils.isBound(card, 'card')) return;
      card.querySelectorAll('.dropdown').forEach(dropdown.bind);

      const jsonEl = card.querySelector('script[type="application/json"][data-askriftir-json]');
      if(!jsonEl){ utils.markBound(card, 'card'); return; }

      let data = {};
      try { data = JSON.parse(jsonEl.textContent || '{}'); } catch(_) {}

      const priceEl = card.querySelector('[data-price]');
      const compareEl = card.querySelector('[data-compare]');
      const imgEl = card.querySelector('[data-card-image]');
      const media = card.querySelector('.askriftir-card__media img');

      const optionOrder = Array.isArray(data.option_order) ? data.option_order : [];
      const selected = {};

    const assigned = [];

    card.querySelectorAll(".dropdown").forEach((d) => {
        const idx = Number(d.dataset.optionIndex);
        // 1) Try normal mapping by index
        let name = (!Number.isNaN(idx) && idx >= 0) ? optionOrder[idx] : undefined;
        // 2) If index is -1 (synthetic) pick the first unassigned option name
        if (!name) name = optionOrder.find(n => !assigned.includes(n)) || optionOrder[0];
        if (!name) return; // product has no options at all
        assigned.push(name);
        // Remember on the element for later changes
        d.dataset.optionName = name;

        const label = (d.querySelector("[data-dropdown-label]")?.textContent || "").trim();
        selected[name] = label;
    });


      const variantEquals = (vOptions, order, sel) => {
        const a = (vOptions || []).map(utils.normalize);
        const b = order.map(name => utils.normalize(sel[name] || ''));
        if (a.length !== b.length) return false;
        for(let i=0;i<a.length;i++){ if(a[i] !== b[i]) return false; }
        return true;
      };
      const partialScore = (vOptions, order, sel) => {
        const a = (vOptions || []).map(utils.normalize);
        const b = order.map(name => utils.normalize(sel[name] || ''));
        let score = 0;
        for(let i=0;i<Math.min(a.length,b.length);i++){ if(a[i] && b[i] && a[i] === b[i]) score++; }
        return score;
      };
      const findVariant = () => {
        const variants = data.variants || [];
        if(!variants.length) return null;

        const realOptionsCount = variants[0]?.options?.length ? variants[0].options.length : 0;
        if(realOptionsCount === 0) return variants.find(isSellable) || variants[0];

        const exact = variants.find(v => variantEquals(v.options, optionOrder, selected));
        if(exact) return exact;

        let best = null, bestScore = -1;
        for(const v of variants){
          const s = partialScore(v.options, optionOrder, selected);
          if(s > bestScore || (s === bestScore && isSellable(v) && !(best && isSellable(best)))){
            best = v; bestScore = s;
          }
        }
        return best || variants[0];
      };
      const pickImage = (v) => {
        const fallback = imgEl?.getAttribute('data-default-src') || data.product_image || (imgEl ? imgEl.src : '');
        return v?.boximage || v?.image || fallback;
      };




      const renderVariant = (v) => {
        if(!v) return;
        const pct = Number(data.discount_pct || 0);
        const base = Math.max(0, 100 - pct);
        const finalPrice = Math.max(0, Math.round(v.price * base / 100)); /// TODO revert after discount days compare_at_price => price
        if(priceEl) priceEl.textContent = utils.money(finalPrice, data.currency);
        if(compareEl){
          compareEl.textContent = utils.money(v.price, data.currency); /// TODO revert after discount days compare_at_price => price
          compareEl.hidden = !(v.price > finalPrice);  /// TODO revert after discount days compare_at_price => price
        }
        if(imgEl){
          const next = pickImage(v);
          if(next && imgEl.src !== next){
            const swap = new Image();
            swap.onload = () => { imgEl.src = next; };
            swap.src = next;
          }
        }

        if (data.is_free) {
            media.style.background = v.bgcolor;
        }

        const ctaBtn = card.querySelector('.askrift-card__add_to_btn, .askriftir-card__add-to-cart-btn');
        const defaultCtaLabel = ctaBtn?.getAttribute('data-default-label') || (ctaBtn?.textContent || '').trim();

        if (ctaBtn) {
            const inStock = isSellable(v);
            ctaBtn.disabled = !inStock;
            ctaBtn.textContent = inStock ? 'Setja í pakka' : 'Uppselt';
            ctaBtn.setAttribute('aria-disabled', String(!inStock));
        }


        card.__askriftCurrentVariant = v;
      };

      const cleanLabel = (s) =>
        (s || '')
            .replace(/\(.*?\)/g, '')           // remove anything in parentheses
            .replace(/\s+/g, ' ')              // collapse spaces
            .trim();

            

        card.addEventListener("dropdown:change", (e) => {
        const wrap = e.target.closest(".dropdown");
        if(!wrap) return;

        const idx = Number(wrap.dataset.optionIndex);
        const fallback = optionOrder.find(n => n === wrap.dataset.optionName) || optionOrder[idx] || optionOrder[0];
        const name = wrap.dataset.optionName || fallback;

        if (name) selected[name] = e.detail.value;
            renderVariant(findVariant());       // updates price/image
        });

      // Add-to-cart from this card (adds 1 and opens cart)
      const form = card.querySelector('form');
        form?.addEventListener('submit', (ev) => {
        ev.preventDefault();
        const v = card.__askriftCurrentVariant || findVariant(); if(!v) return;
        // Uppselt — raunverulega EÐA þvingað — fer aldrei í körfu. Fríu kortin eru undanskilin
        // því refreshFreeButtons() stýrir þeirra takka eftir kvóta, ekki lager.
        if (!data.is_free && !isSellable(v)) return;

        const pct       = Number(data.discount_pct || 0);
        const baseCents = Number(v.price || 0);
        const currCents = Math.round(baseCents * Math.max(0, (100 - pct)) / 100);


        const getOpt = (idx) => (Array.isArray(v.options) && idx >= 0 && idx < v.options.length) ? v.options[idx] : '';

        const flavorLabel = (data.use_custom_flavor && data.custom_flavor_label)
            ? data.custom_flavor_label
            : getOpt(Number(data.flavor_index));

        const qtyLabel = getOpt(Number(data.quantity_index));

        const niceTitle = [flavorLabel, qtyLabel]
            .filter(Boolean)
            .map(cleanLabel)
            .join(' • ');

        // NEW: handle bundle line
        if (data.is_bundle && Array.isArray(data.bundle_items) && data.bundle_items.length) {
            // Build a friendly subtitle like “Whisker • Glerbrúsi”
            const subtitle = data.bundle_items.map(b => b.label).filter(Boolean).join(' • ');

            const cardImgSrc = card.querySelector('[data-card-image]')?.src || '';
            const imgSrc = toUrl(v?.boximage) || toUrl(v?.image) || toUrl(data.product_image) || cardImgSrc;


            window[NS].cart.add({
                is_free: !!data.is_free,
                is_bundle: true,
                bundle_items: data.bundle_items,          // <-- expand at checkout
                product_id: data.product_id,
                title: (card.querySelector('.askriftir-card__title')?.textContent || '').trim(),
                variant_title: subtitle,                  // shows under title
                image: imgSrc, 
                base_cents: baseCents,                    // for strikethrough display
                current_cents: data.is_free ? 0 : currCents,
                quantity: 1,
                bgcolor: v.bgcolor
            });
            return;
        }

        console.log("v", v);

        // regular (non-bundle) flow
            window[NS].cart.add({
                repeat_uuid: v.repeat_uuid || String(v.id),
                product_id: data.product_id,
                variant_id: v.id,
                title: (card.querySelector('.askriftir-card__title')?.textContent || '').trim(),
                variant_title: niceTitle,
                image: (v.boximage || v.image || data.product_image || ''),
                base_cents: baseCents,
                current_cents: currCents,
                quantity: 1,
                is_free: !!data.is_free,
                bgcolor: v.bgcolor
            });
        });


      utils.markBound(card, 'card');

        const first = findVariant();
        renderVariant(first);
    }
  };

  // ------------------------ Mini Cart (encapsulated) ------------------------
  const cart = (() => {
    const STORAGE_KEY = 'askriftCart:v1';
    const FREE_PRICE_CENTS = 0;

    function getConfig(){
        try {
            const el = document.querySelector('[data-askrift-config]');
            return el ? JSON.parse(el.textContent || '{}') : {};
        } catch(_) { return {}; }
    }

    const CFG = getConfig();
    const TARGET_CENTS = Number(CFG.min_spend_cents || 5000 * 100);
    const FREE_LIMIT   = Number(CFG.free_item_limit ?? 1);

    let root, panel, fab, linesEl, totalEl, totalCompareEl, countEls = [], toggleBtn;
    let progressFillEl, progressCurEl, progressTgtEl;
    let subTypeEl, subCountEl;
    let items = [];
    let isOpen = false;

    function bind(rootEl){
      root = rootEl || document.getElementById('askrift-cart-root');
      fab  = document.getElementById('askrift-cart-fab');
      if(!root || utils.isBound(root, 'cart')) return;

      panel = root.querySelector('.askrift-cart__panel');
      linesEl = root.querySelector('[data-askrift-cart-lines]');
      totalEl = root.querySelector('[data-askrift-cart-total]');
      totalCompareEl = root.querySelector('[data-askrift-cart-total-compare]');
      toggleBtn = root.querySelector('[data-askrift-cart-toggle]');
      progressFillEl = root.querySelector('[data-askrift-progress-fill]');
      progressCurEl  = root.querySelector('[data-askrift-progress-current]');
      progressTgtEl  = root.querySelector('[data-askrift-progress-target]');
      countEls = Array.from(document.querySelectorAll('[data-askrift-cart-count]'));
    subTypeEl  = root.querySelector('[data-askrift-sub-type]');
    subCountEl = root.querySelector('[data-askrift-sub-count]');


      const cta = root.querySelector('[data-askrift-checkout]');
        cta?.addEventListener('click', (e) => {
            e.preventDefault();
            checkout();           // <- defined below
        });

      // Open/close
      fab && fab.addEventListener('click', open);
      root.querySelector('.askrift-cart__close')?.addEventListener('click', close);
      document.addEventListener('keydown', (e) => { if(isOpen && e.key === 'Escape') close(); });
      document.addEventListener('click', (e) => {
        if(isOpen && panel && !panel.contains(e.target) && !fab?.contains(e.target)) close();
      });

      // Collapse toggle
      const COLLAPSE_KEY = 'askriftCart:collapsed';
      if (toggleBtn){
        const startCollapsed = true;
        root.classList.toggle('is-collapsed', startCollapsed);
        toggleBtn.textContent = startCollapsed ? 'Skoða körfu' : 'Fela körfu';
        toggleBtn.addEventListener('click', () => {
          const c = root.classList.toggle('is-collapsed');
          localStorage.setItem(COLLAPSE_KEY, c ? '1' : '0');
          toggleBtn.textContent = c ? 'Skoða körfu' : 'Fela körfu';
        });
      }

      if (progressTgtEl) progressTgtEl.textContent = utils.money(TARGET_CENTS, 'ISK');

      load(); render();
      utils.markBound(root, 'cart');
    }

    function freeCount(){
        return items.filter(it => it.is_free === true || it.meta?.free === true).length;
    }
    function canAddFree(){
        return FREE_LIMIT <= 0 ? false : freeCount() < FREE_LIMIT;
    }

    function open(){ if(isOpen || !root) return; isOpen = true; root.hidden = false; root.classList.add('is-open'); panel?.setAttribute('aria-modal','true'); fab?.classList.add('is-hidden'); setTimeout(()=> root.querySelector('.askrift-cart__close')?.focus(), 0); }
    function close(){ if(!isOpen || !root) return; isOpen = false; root.classList.remove('is-open'); panel?.removeAttribute('aria-modal'); fab?.classList.remove('is-hidden'); setTimeout(()=>{ if(!isOpen) root.hidden = true; }, 150); }
    function toggle(){ isOpen ? close() : open(); }

    function load(){ try { items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') || []; } catch(_) { items = []; } }
    function save(){ localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }

    function add(line){
        const isFree = !!line.is_free || !!line.meta?.free;

        // --- Free lines: do not merge, each click adds a new row (qty fixed at 1) ---
        if (isFree){
            if (!canAddFree()){
            render();            // update UI
            open();
            refreshFreeButtons?.(); // keep the “Bætt við” disabled state in sync
            return;
            }

            const copy = {
            ...line,
            is_free: true,
            quantity: 1,        // free lines are always 1
            };

            items.push(copy);      // always create a new row even if same product
            save(); render(); open();
            refreshFreeButtons?.();
            return;
        }

        // --- Paid lines: merge by product/variant and increment quantity ---
        const key = (it) => (it.repeat_uuid||'') + ':' + (it.variant_id||'');
        const i = items.findIndex(it => !it.is_free && key(it) === key(line));

        if (i > -1){
            items[i].quantity += (line.quantity || 1);
        } else {
            items.push({ ...line, is_free: false, quantity: Math.max(1, line.quantity || 1) });
        }

        save(); render(); open();
        refreshFreeButtons?.();
    }



    function changeQty(i, q){
        if(!items[i]) return;

        if (items[i].is_free){
            if (q <= 0) { remove(i); return; }   // allow removal
            return;                              // ignore attempts to change qty
        }

        if(q <= 0){ remove(i); return; }
        items[i].quantity = q;
        save(); render();
    }
    function remove(i){ items.splice(i,1); save(); render(); refreshFreeButtons(); if(!items.length) close(); }
    function clear(){ items = []; save(); render(); refreshFreeButtons(); close(); }

    function render(){
      if (!linesEl) return;

      if (!items.length){
        linesEl.innerHTML = `<div style="padding:16px;color:#666">Ekkert valið í áskrift.</div>`;
      } else {
        linesEl.innerHTML = items.map((it, idx) => {
        const qtyLabel = it.quantity > 1 ? ` × ${it.quantity}` : '';
        const baseT = (Number(it.base_cents)||0) * it.quantity;
        const currT = (Number(it.current_cents)||0) * it.quantity;

        if (it.is_bundle) {
            const compare = Number(it.base_cents) || 0;
            const curr    = Number(it.current_cents) || 0;

            return `
                <div class="askrift-cart__line ${it.is_free ? 'is-free' : ''}" data-index="${idx}">
                <img class="askrift-cart__thumb" src="${it.image||''}" alt="">
                <div>
                    <div class="askrift-cart__title-line">
                    <h4 class="askrift-cart__title">${it.title || 'Pakki'}</h4>
                    </div>
                    <div class="askrift-cart__variant">${it.variant_title || ''}</div>
                    ${it.is_free ? `
                    <button type="button" data-act="rm" aria-label="Fjarlægja" class="askrift-cart__remove" style="display:flex;gap:6px;margin-top:6px;">
                        <svg class="askrift-cart__remove-icon" width="16" height="16" viewBox="0 0 20 20" aria-hidden="true">
                        <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/>
                        </svg>
                        Fjarlægja
                    </button>` : `
                    <div class="askrift-cart__qty" style="margin-top:6px">
                        <button type="button" data-act="dec" aria-label="Minnka" class="is-minus"></button>
                        <span>${it.quantity}</span>
                        <button type="button" data-act="inc" aria-label="Auka" class="is-plus"></button>
                    </div>`}
                </div>
                <div class="askrift-cart__prices">
                    ${compare ? `<div class="askrift-cart__compare">${utils.money(compare * (it.quantity||1), 'ISK')}</div>` : ''}
                    <div class="askrift-cart__current">${utils.money((it.is_free ? 0 : curr) * (it.quantity||1), 'ISK')}</div>
                </div>
                </div>`;
            }


        if (it.is_free) {
            const compare = Number(it.base_cents) || 0; // show compare if you have one
            const subtitle = it.variant_title || it.free_label || '';
            const bgcolor = it.bgcolor;
            return `
            <div class="askrift-cart__line is-free" data-index="${idx}">
                <div style="background-color: ${bgcolor}; border-radius: 8px;">
                    <img class="askrift-cart__thumb" src="${it.image||''}" alt="">
                </div>
                <div>
                <div class="askrift-cart__title-line">
                    <h4 class="askrift-cart__title">${it.title || 'Frí vara'}</h4>
                </div>
                <div class="askrift-cart__variant">${subtitle}</div>
                <button type="button" data-act="rm" aria-label="Fjarlægja" class="askrift-cart__remove" style="display:flex;gap:6px;margin-top:6px;">
                    <svg class="askrift-cart__remove-icon" width="16" height="16" viewBox="0 0 20 20" aria-hidden="true">
                    <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/>
                    </svg>
                    Fjarlægja
                </button>
                </div>
                <div class="askrift-cart__prices">
                ${compare ? `<div class="askrift-cart__compare">${utils.money(compare, 'ISK')}</div>` : ''}
                <div class="askrift-cart__current">${utils.money(0, 'ISK')}</div>
                </div>
            </div>`;
        }

        // paid line (unchanged)
        return `
            <div class="askrift-cart__line" data-index="${idx}">
            <img class="askrift-cart__thumb" src="${it.image||''}" alt="">
            <div>
                <div class="askrift-cart__title-line">
                <h4 class="askrift-cart__title">${it.title||''}</h4>
                </div>
                <div class="askrift-cart__variant">${it.variant_title||''}${qtyLabel}</div>
                <div class="askrift-cart__qty">
                <button type="button" data-act="dec" aria-label="Minnka" class="is-minus"></button>
                <span>${it.quantity}</span>
                <button type="button" data-act="inc" aria-label="Auka" class="is-plus"></button>
                </div>
            </div>
            <div class="askrift-cart__prices">
                <div class="askrift-cart__compare">${utils.money(baseT, 'ISK')}</div>
                <div class="askrift-cart__current">${utils.money(currT, 'ISK')}</div>
            </div>
            </div>`;
        }).join('');


        refreshFreeButtons();
      }

        // qty delegate
        linesEl.onclick = (e) => {
        const line = e.target.closest('.askrift-cart__line'); if(!line) return;
        const i = Number(line.dataset.index||'-1'); if(i<0) return;

        if (e.target.matches('[data-act="rm"], .askrift-cart__remove, .askrift-cart__remove *')) {
            remove(i);
            e.stopPropagation();
            return;
        }

        if (e.target.matches('[data-act="inc"]')) changeQty(i, items[i].quantity + 1);
        if (e.target.matches('[data-act="dec"]')) changeQty(i, Math.max(0, items[i].quantity - 1));
        e.stopPropagation();
        };

      // totals
      const totals = items.reduce((acc, it) => {
        acc.current += (Number(it.current_cents)||0) * it.quantity;
        acc.compare += (Number(it.base_cents)||0) * it.quantity;
        return acc;
      }, { current: 0, compare: 0 });

      if (totalEl) totalEl.textContent = utils.money(totals.current, 'ISK');
      if (totalCompareEl){
        const hide = !items.length || totals.compare<=0 || totals.compare===totals.current;
        totalCompareEl.textContent = hide ? '' : utils.money(totals.compare, 'ISK');
        totalCompareEl.style.display = hide ? 'none' : '';
      }

      // counts
      const totalQty = items.reduce((n, it) => n + it.quantity, 0);
      countEls.forEach(el => el.textContent = String(totalQty));

      // progress
      const pct = Math.max(0, Math.min(1, totals.current / TARGET_CENTS));
      if (progressFillEl) progressFillEl.style.width = (pct * 100) + '%';
      if (progressCurEl)  progressCurEl.textContent = utils.money(totals.current, 'ISK');
      if (progressTgtEl)  progressTgtEl.textContent = utils.money(TARGET_CENTS, 'ISK');

      // CTA (placeholder)
        const cta = root.querySelector('[data-askrift-checkout]');
        if (cta){
        const missing = Math.max(0, TARGET_CENTS - totals.current);
        const okToCheckout = items.length > 0 && missing === 0;

        cta.disabled   = !okToCheckout;
        cta.textContent = okToCheckout
            ? 'Klára kaup'
            : `Bættu við ${utils.money(missing, 'ISK')} til að halda áfram`;
        }

      document.dispatchEvent(new CustomEvent('askrift:cart:render', { detail: { count: totalQty }}));
    }


    function refreshFreeButtons(){
        // Scan all cards and toggle their button if they represent a free item
        document.querySelectorAll('.askriftir-card').forEach((card) => {
            const jsonEl = card.querySelector('script[type="application/json"][data-askriftir-json]');
            if (!jsonEl) return;

            let data = {};
            try { data = JSON.parse(jsonEl.textContent || '{}'); } catch(_){}

            if (!data.is_free) return;

            const btn = card.querySelector('.askrift-card__add_to_btn, .askriftir-card__add-to-cart-btn');
            if (!btn) return;

            const locked = !canAddFree();        // i.e. limit reached
            btn.disabled = locked;
            btn.textContent = locked ? 'Bætt við' : (btn.dataset.defaultLabel || 'Setja í pakka');
        });
    }

    function openFreebieModal(){
        const wrap = document.querySelector('[data-askrift-freebie]');
        if (!wrap) return false;

        // wire once
        if (!wrap.__wired){
            wrap.addEventListener('click', (e) => {
            if (e.target.matches('[data-act="close"]')) wrap.hidden = true;
            });
            const proceed = wrap.querySelector('[data-act="proceed"]');
            const choose  = wrap.querySelector('[data-act="choose"]');

            proceed?.addEventListener('click', () => {
            wrap.hidden = true;
            // continue to real checkout
            window.location.href = buildRepeatURL();
            });

            choose?.addEventListener('click', () => {
            wrap.hidden = true;
            // optional: close cart and nudge to first free card
            close?.();
            const freeCard = document.querySelector('.askriftir-card .askriftir-card__badge.is-free')?.closest('.askriftir-card');
            if (freeCard){
                freeCard.classList.add('askrift-pulse');
                freeCard.scrollIntoView({ behavior:'smooth', block:'center' });
                setTimeout(()=> freeCard.classList.remove('askrift-pulse'), 1200);
            }
            });

            wrap.__wired = true;
        }

        wrap.hidden = false;
        return true;
    }



    function currentTotalCents(){
        return (items || []).reduce((acc, it) => acc + (Number(it.current_cents)||0) * (it.quantity||1), 0);
    }

    function getRepeatBaseUrl(){
        const attr = root?.getAttribute('data-repeat-base-url');
        return (window.AskriftRepeat && window.AskriftRepeat.baseUrl)
            || attr
            || 'https://repeat.is/repeat_checkout/21f7372a-a033-4f62-8fa4-5f5c23a04869/';
    }

    function buildRepeatURL(){
        const baseUrl = getRepeatBaseUrl();
        const type  = (subTypeEl?.value || 'MONTH').toUpperCase();
        const count = parseInt(subCountEl?.value || '1', 10) || 1;

        const url = new URL(baseUrl);
        let row = 0;

        (items || []).forEach((it) => {
            // Expand bundle: add each sub-uuid once per line quantity
            if (it.is_bundle && Array.isArray(it.bundle_items) && it.bundle_items.length) {
                const qty = Math.max(1, it.quantity || 1);
                for (let q = 0; q < qty; q++) {
                    it.bundle_items.forEach(sub => {
                    const uuid = (sub && typeof sub.uuid === 'string') ? sub.uuid.trim() : '';
                    if (!uuid) return; // <- hard skip empty/invalid
                    url.searchParams.append(`products.${row}.uuid`, uuid);
                    url.searchParams.append(`products.${row}.quantity`, '1');
                    url.searchParams.append(`products.${row}.interval_count`, String(count));
                    url.searchParams.append(`products.${row}.interval_type`, type);
                    row++;
                    });
                }
                return;
            }

            // normal line
            const uuid = it.repeat_uuid || it.uuid;
            if (!uuid) return;
            url.searchParams.append(`products.${row}.uuid`, uuid);
            url.searchParams.append(`products.${row}.quantity`, String(it.quantity || 1));
            url.searchParams.append(`products.${row}.interval_count`, String(count));
            url.searchParams.append(`products.${row}.interval_type`, type);
            row++;
        });

        return url.toString();
    }


    function checkout(){
        if (!items?.length) return;
        if (currentTotalCents() < TARGET_CENTS) return;

        // If user is eligible for free items but hasn't added max yet → nudge
        if (canAddFree() && openFreebieModal()) {
            return; // stop here; proceed button will continue
        }

        // otherwise go straight to checkout
        window.location.href = buildRepeatURL();
    }


    return { bind, open, close, toggle, add, clear, _load: load, _save: save };
  })();

  // ------------------------- Public API -------------------------
  const api = {
    init(root){
      const scope = root || document;
      scope.querySelectorAll('.askriftir-card').forEach(cards.hydrate);
    },
    initAll(){
      document.querySelectorAll('[id^="askriftir-"]').forEach((root) => api.init(root));
      const cartRoot = document.getElementById('askrift-cart-root');
      if (cartRoot) cart.bind(cartRoot);

      // Optional: let site header open our cart too if present
      document.getElementById('headerIconsCart')?.addEventListener('click', (e)=>{ e.preventDefault(); cart.open(); });
      document.querySelector('.openCart')?.addEventListener('click', (e)=>{ e.preventDefault(); cart.open(); });
    },
    destroy(root){},
    cart,
    utils,
  };

  if(!window[NS]) window[NS] = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window[NS].initAll());
  } else {
    window[NS].initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const container = e.target || e.detail?.section;
    if (container) window[NS].init(container);
    const cartRoot = document.getElementById('askrift-cart-root');
    if (cartRoot) window[NS].cart.bind(cartRoot);
  });
})();
